import { IconButton } from '@mui/material';
import { styled } from '@mui/system';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  padding: '0.5rem',
  alignItems: 'center',
  gap: '0.5rem',
  borderRadius: '0.5rem',
  border: `1px solid ${theme.palette.grey[200]}`,
  width: '100%',
  cursor: 'pointer',
}));

export const Thumbnail = styled('img')(() => ({
  width: '3.5rem',
  height: '3.5rem',
  flexShrink: 0,
  borderRadius: '0.25rem',
}));

export const Title = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '0.875rem',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '150%',
  color: theme.palette.grey[800],
  wordBreak: 'break-word',
}));

export const VersionTag = styled('div', {
  shouldForwardProp: (propName: string) => propName !== 'current',
})<{ current?: boolean }>(({ theme, current }) => ({
  display: 'flex',
  width: '1.5rem',
  height: '1.5rem',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '0.25rem',
  border: `1px solid ${current ? theme.palette.green[600] : theme.palette.grey[500]}`,

  '& p': {
    margin: 0,
    fontSize: '0.75rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '160%',
    color: current ? theme.palette.green[600] : theme.palette.grey[500],
  },
}));

export const MenuButton = styled(IconButton)(({ theme }) => ({
  padding: 0,
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
  },
}));
